module.exports = __webpack_public_path__ + "static/media/a1.a14d5228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArcadeRoyale/a1.jpg
// module id = 161
// module chunks = 0